import { API, authClient } from "../index";

// Get tip by id
export const getTipById = (id) => {
  return authClient().get(`${API}/tip/${id}`);
};
export const getTips = () => {
  return authClient().get(`${API}/tip`);
};

// Create tip
export const postTip = async (tip) => {
  return authClient().post(`${API}/tip`, tip);
};

// Update tip
export const updateTip = async (id, tip) => {
  return authClient().put(`${API}/tip/${id}`, tip);
};

// Send client invoice without saving email on the tip
export const sendClientInvoice = async (id, email) => {
  return authClient().post(`${API}/tip/${id}/send-client-invoice`, { email });
};

// "Pagar con el datáfono Tipify": avisar a la app TPV del local
/**
 * Pide al camarero que cobre la propina con la app TPV.
 * @param {{ ubicacion?: string | null }} options dónde está el cliente (opcional).
 */
export const solicitarTpv = async (id, { ubicacion } = {}) => {
  const clean = typeof ubicacion === "string" ? ubicacion.trim() : "";
  const body = clean ? { ubicacion: clean } : {};
  return authClient().post(`${API}/tip/${id}/solicitar-tpv`, body);
};

export const getSolicitudTpvEstado = (id) => {
  return authClient().get(`${API}/tip/${id}/solicitar-tpv/estado`);
};

export const cancelarSolicitudTpv = async (id) => {
  return authClient().post(`${API}/tip/${id}/solicitar-tpv/cancelar`, {});
};
